import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-double-copy-small",
  "use": "foquz-icon-double-copy-small-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol viewBox=\"0 0 15 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-double-copy-small\"><path d=\"M11 9h1a2 2 0 002-2V3a2 2 0 00-2-2H8a2 2 0 00-2 2v1M3 14h4a2 2 0 002-2V8a2 2 0 00-2-2H3a2 2 0 00-2 2v4a2 2 0 002 2z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol